module.exports = __webpack_public_path__ + "static/media/human_pet.6aecd19b.svg";